<form [formGroup]='movingSize'
	(ngSubmit)='onSubmit()'
	id='{{formGroupName}}'>

	<div class='step-title' i18n><span class='color-blue'>What</span> are you moving?</div>

	<div class='form-control'>
		<mat-radio-group formControlName='movingSize' aria-label='Select an option' class='custom-radio-group'>
			<mat-radio-button *ngFor='let movingSize of getMovingSizes()'
			                  [value]='movingSize.value'
			                  [tabIndex]='formService.verifyTabIndex( formGroupName )'>
				<div class='option'>
					<mat-icon inline="true" [svgIcon]='movingSize.image' class='option-icon'></mat-icon>
					<div class='option-name'>{{movingSize.label}}</div>
				</div>
			</mat-radio-button>
		</mat-radio-group>
	</div>
	<div class='step-footer step-footer-center'>
		<div class='step-footer-buttons'>
			<button class='back' type='button' (click)='formService.backMainForm()'><mat-icon svgIcon='icons:chevron-left'></mat-icon><ng-container i18n='@@buttonBack'>Back</ng-container></button>
			<button class='submit' type='submit'><ng-container i18n='@@buttonContinue'>Continue</ng-container><mat-icon svgIcon='icons:chevron-right'></mat-icon></button>
		</div>
	</div>
</form>